import LogoHeading from '../../LogoHeading/LogoHeading';
import MyAccount from '../../MyAccount/MyAccount';

const SignupLayoutHeading = () => {
  return (
    <>
      <MyAccount isDesktop />
      <LogoHeading />
    </>
  );
};

export default SignupLayoutHeading;
